const MAX_CURRENCY_PRECISION = 2;

export function formatCurrency(amount, precision = MAX_CURRENCY_PRECISION) {
  if (precision <= 1 && isWholeAmountByPrecision(amount, 0)) {
    return `$${amount | 0}`;
  }

  if (precision <= 1 && isWholeAmountByPrecision(amount, 1)) {
    return `$${amount.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '&,')}`;
  }

  // Always return with precision of two decimal points as default
  return formatAmount(amount, MAX_CURRENCY_PRECISION);
}

function isWholeAmountByPrecision(amount, precision) {
  return ((10 ** precision) * amount) % 1 === 0;
}

function formatAmount(amount, precision) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}